const setupSubscribeFooter = () => {
  const $form = $('.footer-subscribe-form')

  if (!$form.length) {
    return
  }

  $form.on('submit', (e) => {
    e.preventDefault()

    $.ajax({
      type: 'post',
      dataType: 'json',
      data: $form.serialize(),
      url: $form.prop('action'),
      beforeSend: () => {
        $form.find('button[type=submit]').prop('disabled', true)
        $form.find('.form-subscribe-message').hide()
        $form.find('.form-success-message').hide()
      },
      success: (resp) => {
        if (resp.success) {
          $form.find('.form-success-message').text(resp.data.message).show()
        }
        else {
          $form.find('.form-subscribe-message').text(resp.data.message).show()
        }

        $form.find('input[type=email]').val(null)

        setTimeout(() => {
          $form.find('.form-success-message, .form-subscribe-message').hide()
        }, 4000)
      },
      complete: () => {
        $form.find('button[type=submit]').prop('disabled', false)
      }
    })
  })
}

setupSubscribeFooter()
